module.exports = __webpack_public_path__ + "img/users.bac88168.svg";